const USER_NOT_FOUND = 'UserNotFoundException';
const FEDERATED_TYPE = 'federated';
const COGNITO_PROVIDER = 'cognito';
const FACEBOOK_PROVIDER = 'facebook';
const GENERAL_SIGNUP_ERROR = 'Signup failed';
const GOOGLE_PROVIDER = 'google';
const USERNAME_EXISTS = 'User already exists'; // todo: wapi endpoint should send exception
const INVALID_PARAMETER = 'InvalidParameterException';
const INVALID_PASSWORD = 'InvalidPasswordException';
const LIMIT_EXCEEDED = 'LimitExceededException';
const NOT_AUTHORIZED = 'NotAuthorizedException';
const LOCAL_STORAGE_KEY = 'userAccessToken';

export {
    COGNITO_PROVIDER,
    FACEBOOK_PROVIDER,
    FEDERATED_TYPE,
    GENERAL_SIGNUP_ERROR,
    GOOGLE_PROVIDER,
    INVALID_PARAMETER,
    INVALID_PASSWORD,
    LIMIT_EXCEEDED,
    LOCAL_STORAGE_KEY,
    NOT_AUTHORIZED,
    USERNAME_EXISTS,
    USER_NOT_FOUND,
};
